var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5C0 5.5957 5.5957 0 12.5 0C19.4043 0 25 5.5957 25 12.5C25 19.4043 19.4043 25 12.5 25C5.5957 25 0 19.4043 0 12.5ZM10.0781 17.5074L18.8549 8.70129C19.1967 8.35949 19.1967 7.80285 18.8525 7.45861C18.5082 7.11682 17.9516 7.11682 17.6098 7.46105L9.61419 15.4811L7.52923 11.8312C7.28997 11.4088 6.75286 11.2623 6.3305 11.504C5.90814 11.7433 5.76165 12.2804 6.00335 12.7028L8.66204 17.3512C8.82317 17.6368 9.12103 17.7955 9.4262 17.7955C9.57269 17.7955 9.72405 17.7589 9.86077 17.6808C9.9389 17.6368 10.0097 17.5807 10.0683 17.5172L10.0781 17.5074Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.713fedcb91a771a9bf138e5e31787866.svg";
export { ForwardRef as ReactComponent };